module.exports = __webpack_public_path__ + "static/fonts/fa-brands-400.5e8aa9e.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fontawesome-5.10.2/webfonts/fa-brands-400.ttf
// module id = 335
// module chunks = 1